function acortarTexto(texto, cantidadCaracteres = 15) {
    return `${texto.substring(0, cantidadCaracteres)}...`;
}

export default acortarTexto;
